<ion-page>
  <ion-content class="fade-slide-enter">
    <div class="page-shell">
      <div class="page-content">
        <div class="layout">
          <div class="hero glass-card">
            <div>
              <div class="eyebrow">{{ 'app.title' | t }}</div>
              <h1 class="page-title">{{ 'landing.hero.title' | t }}</h1>
              <p class="subtitle">{{ 'landing.hero.subtitle' | t }}</p>
              <div class="cta">
                <ion-button class="futuristic-button" (click)="goToConvert()">{{ 'landing.cta.convert' | t }}</ion-button>
              </div>
            </div>
            <div class="illustration glass-card">
              <div class="abstract-visual">
                <svg viewBox="0 0 420 320" preserveAspectRatio="xMidYMid meet" aria-hidden="true">
                  <defs>
                    <linearGradient id="panelGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stop-color="#7ee3ff" stop-opacity="0.6" />
                      <stop offset="100%" stop-color="#8f7bff" stop-opacity="0.4" />
                    </linearGradient>
                    <linearGradient id="waveGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                      <stop offset="0%" stop-color="#7ee3ff" stop-opacity="0.9" />
                      <stop offset="100%" stop-color="#c1a4ff" stop-opacity="0.9" />
                    </linearGradient>
                    <radialGradient id="orbGradient" cx="50%" cy="50%" r="70%">
                      <stop offset="0%" stop-color="#d8f3ff" stop-opacity="0.9" />
                      <stop offset="100%" stop-color="#6d8dff" stop-opacity="0.25" />
                    </radialGradient>
                    <linearGradient id="triangleGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                      <stop offset="0%" stop-color="#e0f7ff" stop-opacity="0.9" />
                      <stop offset="100%" stop-color="#7c6bff" stop-opacity="0.6" />
                    </linearGradient>
                    <filter id="softBlur" x="-30%" y="-30%" width="160%" height="160%">
                      <feGaussianBlur stdDeviation="16" />
                    </filter>
                  </defs>
                  <rect x="46" y="44" width="328" height="222" rx="28" class="panel" />
                  <rect x="70" y="68" width="280" height="176" rx="22" class="panel panel-overlay" />
                  <g class="grid">
                    <line x1="100" y1="88" x2="320" y2="88" />
                    <line x1="100" y1="132" x2="320" y2="132" />
                    <line x1="100" y1="176" x2="320" y2="176" />
                    <line x1="100" y1="220" x2="320" y2="220" />
                    <line x1="140" y1="88" x2="140" y2="220" />
                    <line x1="210" y1="88" x2="210" y2="220" />
                    <line x1="280" y1="88" x2="280" y2="220" />
                  </g>
                  <g class="arcs">
                    <path d="M126 230 Q190 196 254 214 T340 214" />
                    <path d="M90 118 Q172 74 252 108 T360 108" />
                  </g>
                  <g class="wave">
                    <path d="M78 186 C118 172 148 192 188 178 C226 166 256 184 292 174 C322 166 340 180 344 186" />
                  </g>
                  <polygon class="triangle" points="222,148 272,170 222,192" />
                  <polygon class="triangle subtle" points="154,122 188,138 154,154" />
                  <circle class="orb" cx="134" cy="188" r="40" />
                  <circle class="orb secondary" cx="292" cy="126" r="34" />
                  <circle class="halo" cx="120" cy="118" r="16" />
                  <circle class="halo" cx="306" cy="214" r="18" />
                  <g class="nodes">
                    <circle cx="180" cy="120" r="6" />
                    <circle cx="246" cy="198" r="6" />
                    <circle cx="314" cy="156" r="5" />
                  </g>
                  <g class="connectors">
                    <line x1="186" y1="120" x2="230" y2="156" />
                    <line x1="230" y1="156" x2="246" y2="198" />
                    <line x1="246" y1="198" x2="314" y2="156" />
                  </g>
                  <circle class="glow-veil" cx="206" cy="160" r="82" filter="url(#softBlur)" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ion-content>
</ion-page>
